import LayoutPage from "../../Components/LayoutPage";
import TradesHistory from "./Components/TradesHistory";

export default function Trades() {
  return (
    <LayoutPage
      activeIndex={17}
      navItems={["مدیریت معاملات"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto"
    >
      <TradesHistory />
    </LayoutPage>
  );
}
